<div class="page-overlay-wrapper center" *ngIf="showSpinner">
    <mat-spinner diameter="50" class="spinner"></mat-spinner>

</div>